import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../constants/endpoints";
import api from "../../services/instance";
import { toast } from "react-toastify";

export const updateUserProfileAPI = createAsyncThunk(
    'updateUserProfileAPI',
    async (data, { rejectWithValue }) => {
        try {
            const id = data.get('id')
            const response = await api.post(endpoints.updateUserProfile(id), data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    loading: false
}

const UpdateUserProfileSlice = createSlice({
    initialState,
    name: "UpdateUserProfileSlice",
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(updateUserProfileAPI.pending, (state, action) => {
            state.loading = true;
        })

        builder.addCase(updateUserProfileAPI.fulfilled, (state, action) => {
            state.loading = false;
            localStorage.setItem("user", JSON.stringify(action.payload.data.data));
        })

        builder.addCase(updateUserProfileAPI.rejected, (state, action) => {
            state.loading = false;
        })
    }
})

export const { } = UpdateUserProfileSlice.actions
export default UpdateUserProfileSlice.reducer